import { collection, type FirestoreDataConverter, getFirestore } from 'firebase/firestore'
import { type z } from 'zod'

import { TeamLocationZod } from '@/model/firestore/schema/TeamLocationZod.ts'
import { ErrorWithSentryCaptureContext } from '@/sentry/ErrorWithSentryCaptureContext.ts'

export type TeamLocationSnapshotData = z.infer<typeof TeamLocationZod> & { _id: string }

const TeamLocationConverter: FirestoreDataConverter<TeamLocationSnapshotData> = {
  toFirestore: (data) => data,
  fromFirestore: (snapshot, options) => {
    const result = TeamLocationZod.safeParse(snapshot.data(options))
    if (!result.success) {
      throw new ErrorWithSentryCaptureContext(
        `Invalid team location ${snapshot.ref.path}`,
        {
          tags: { 'firestore.zod': 'teams.locations' },
          fingerprint: ['firestore', 'zod', 'teams.locations'],
          extra: { data: snapshot.data(options), document: { path: snapshot.ref.path } },
        },
        { cause: result.error }
      )
    }
    return { _id: snapshot.id, ...result.data }
  },
}

export const teamLocationCollection = (teamId: string) =>
  collection(getFirestore(), `teams/${teamId}/locations`).withConverter(TeamLocationConverter)
